import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button';
import { Head, Container, Content, Footer } from './styles';

const EarlyCheckIn = () => {

  const navigate = useNavigate()

  return (
    <Container>
      <Content>
        <Head>Something went wrong, please try again!</Head>
        <Footer>
          <Button
            mainPage
            onClick={(event) => {
              if (event.metaKey || event.ctrlKey) {
                // Open new tab with absolute URL
                window.open(`https://pms.rookhotel.com/`, '_blank', 'noopener,noreferrer');
              } else {
                // Normal navigation
                navigate('/floor')
              }
            }}
            additionalstyle={`
              width: 154px;
            `}
          >
            Back To Home
          </Button>
        </Footer>
      </Content>
    </Container>
  );
}

export default EarlyCheckIn;